import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {useDebounce, KTIcon, ID} from '@/_metronic/helpers'
import {RegistredProduct} from '../../core/_models'

type Props = {
  push: (value: unknown) => void;
  products: Array<RegistredProduct>
  selected: Array<ID>
}

const Lookup: React.FC<Props> = ({push, products, selected}) => {
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [matches, setMatches] = useState<Array<RegistredProduct>>([])
  const debouncedSearchTerm = useDebounce(searchTerm, 150)
  const search = async () => {
    if (debouncedSearchTerm !== undefined && searchTerm.length >= 3) {
      setLoading(true)
      const tmp : RegistredProduct[] = []
      const rgxp = new RegExp(searchTerm, 'i')

      products.forEach((p: RegistredProduct) => {
        if (p.name.match(rgxp) || p.brand.match(rgxp)) {
          tmp.push(p)
        }
      })

      setMatches(tmp)
      setLoading(false)
    } else {
      setMatches([])
    }
  }

  useEffect(() => {
    search()
  }, [products, debouncedSearchTerm])

  return (
    <>
      <div className='separator separator-dashed my-5'></div> 
      <div className="position-relative mb-3">
        <KTIcon
          iconName='magnifier'
          className='fs-2 text-lg-1 text-gray-500 position-absolute top-50 translate-middle-y ms-0'
        />

        <input
          name="search"
          type="text"
          placeholder="Search product ..."
          className="form-control form-control-flush ps-10"
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
          disabled={loading}
          autoComplete='off'
        />

        {loading && (
          <span
            className='position-absolute top-50 end-0 translate-middle-y lh-0 me-1'
            data-kt-search-element='spinner'
          >
            <span className='spinner-border h-15px w-15px align-middle text-gray-400' />
          </span>
        )}
        {searchTerm && !loading && (
          <span
            className='btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0'
            data-kt-search-element='clear'
            onClick={() => {
              setSearchTerm('')
              setMatches([])
            }}
          >
            <KTIcon iconName='cross' className='fs-2 text-lg-1 me-0' />
          </span>
        )}
      </div>
      <div className="row">
        {searchTerm.length > 0 && !loading && matches.length === 0 && (
          <div className="col-12 text-danger text-center">
            No product found
          </div>
        )}
        {matches.map((m: RegistredProduct, index: number) => (
          <div className="col-4 mb-5" key={`lookup-${index}`}>
            <div
              className={clsx(
                "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center justify-content-between",
                { 'active disabled': selected.find((id: ID) => id === m._id) !== undefined }
              )}
              onClick={() => push({
                name: m.name,
                qty: '',
                product: m._id,
                amount: m.availability.pricing.amount,
                discount: m.availability.pricing.discount,
                vat: m.availability.pricing.vat,
                stock: m.stock,
                threshold: m.threshold
              })}
            >
              <span>{m.name}</span>
                <span className="d-flex align-items-center gap-2">
                  <span className="badge badge-primary fw-semibold">{m.stock}</span>
                  <span className="badge badge-danger fw-bold">{m.threshold}</span>
                </span>
            </div>
          </div>
        ))}
      </div>
      <div className='separator separator-dashed my-5'></div> 
    </>
  )
}

export default Lookup
